export const mapActions = {
    'login': 'Авторизация ',
    'logout': 'Выход из системы',
    'update': 'Обновление',
    'create': 'Создание',
}

export const mapEntity = {
    'Order': 'Заказ',
    'Product': 'Продукт',
    'Payment': 'Оплата',
    'User': 'Пользователи',
    'Supplier': 'Поставщики',
    'Category': 'Категории товаров'
}

export const actions = [
  { key: "create", name: "Создать" },
  { key: "update", name: "Обновить" },
  { key: "delete", name: "Удалить" },
  { key: "login", name: "Войти" },
  { key: "logout", name: "Выйти" },
];